import React from 'react';
import './HeroBanner.scss';
import { track } from "../analytics/meta";

const HeroBanner = () => {
  return (
    <section className="hero-banner" id='top'>
      <div className='col-lg-7 col-12'>
        <h1>Un puente que une corazones</h1>
        <h2>Conecta con personas que comparten tu cultura, tus raíces y tu forma de amar.</h2>
        <span className='d-flex align-items-center flex-lg-row flex-column'>
          <a 
            href="https://play.google.com/store/apps/details?id=com.kuska.kuskapp" 
            className='btn-download'
            onClick={() => track("DownloadPlayStore", { source: "home_banner" })}  
          >Descargar - Play Store</a>
          <p className='btn-app-store'>Próximamente - App Store</p>
        </span>
      </div>
      <div className='col-lg-5 col-12 d-none d-lg-flex justify-content-center align-items-center'>
        <img src="/elementos-graficos/CHAKANA (1).png" alt="Mockup phone con logo de Kuska" />
      </div>
    </section>
  );
};

export default HeroBanner;